import React from 'react';
import { Input } from '../../../../components/input';
import editIcon from '../../../../../assets/icons/edit.png';
import { MAX_TEXT_LENGTH } from '../constants';

interface TextAreaFieldProps {
  label: string;
  value: string;
  fieldName: string;
  showColon?: boolean;
  isEditing: boolean;
  editingValue: string;
  loading: boolean;
  onStartEdit: (field: string, value: any) => void;
  onSave: (field: string, value: any) => void;
  onCancel: () => void;
  onValueChange: (value: any) => void;
}

export const TextAreaField: React.FC<TextAreaFieldProps> = ({
  label,
  value,
  fieldName,
  showColon = true,
  isEditing,
  editingValue,
  loading,
  onStartEdit,
  onSave,
  onCancel,
  onValueChange
}) => {
  const renderHistoryEduIcon = () => (
    <span className='material-icons section-icon'>history_edu</span>
  );

  if (isEditing) {
    return (
      <div className='about-section editing'>
        <div className='section-header'>
          <h4>
            {renderHistoryEduIcon()}
            {label}{showColon ? ':' : ''}
          </h4>
        </div>
        <div className='edit-controls'>
          <Input
            name={fieldName}
            type='textarea'
            value={editingValue}
            onChange={onValueChange}
          />
          <div className={`char-count ${(editingValue?.length || 0) > MAX_TEXT_LENGTH ? 'exceeded' : ''}`}>
            {editingValue?.length || 0}/{MAX_TEXT_LENGTH} caracteres
            {(editingValue?.length || 0) > MAX_TEXT_LENGTH && (
              <span className='exceeded-message'> ({(editingValue?.length || 0) - MAX_TEXT_LENGTH} caracteres acima do limite)</span>
            )}
          </div>
          <div className='edit-actions'>
            <button 
              className='save-btn' 
              onClick={() => onSave(fieldName, editingValue)}
              disabled={loading}
            >
              Salvar
            </button>
            <button 
              className='cancel-btn' 
              onClick={onCancel}
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='about-section'>
      <div className='section-header'>
        <h4>
          {renderHistoryEduIcon()}
          {label}{showColon ? ':' : ''}
        </h4>
        <img 
          src={editIcon} 
          alt='edit' 
          className='edit-icon' 
          onClick={() => onStartEdit(fieldName, value)}
        />
      </div>
      <div className='section-content'>
        {value || '-'}
      </div>
    </div>
  );
};

